import { render } from "./HeaderBar.vue?vue&type=template&id=5321bc4c&ts=true"
import script from "./HeaderBar.vue?vue&type=script&lang=ts"
export * from "./HeaderBar.vue?vue&type=script&lang=ts"

import "./HeaderBar.vue?vue&type=style&index=0&id=5321bc4c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__